import { ReactNode, SyntheticEvent } from 'react';

import { CarInfoBaseProps } from './types';

type CarInfoCardBaseProps = {
  base: CarInfoBaseProps;
  infoSlot?: ReactNode;
  bannerSlot?: ReactNode;
  className?: string;
  layout?: 'row' | 'column';
};

export const CarInfoCardBase = ({
  base,
  infoSlot,
  bannerSlot,
  className,
  layout = 'row',
}: CarInfoCardBaseProps) => {
  const isRow = layout === 'row';
  const handleImageError = (event: SyntheticEvent<HTMLImageElement>) => {
    event.currentTarget.src = '/NOT_FOUND_CAR.png';
  };

  const imageContainerStyle = isRow
    ? {
        display: 'flex',
        flexShrink: 0,
        flexDirection: 'column' as const,
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '200px',
      }
    : {
        display: 'flex',
        flexShrink: 0,
        flexDirection: 'column' as const,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '12px',
      };
  const imageStyle = {
    width: '158px',
    marginTop: isRow ? '30px' : undefined,
  };
  const noteStyle = {
    color: '#9f9f9f',
    fontSize: '12px',
    fontWeight: 300,
    lineHeight: '22px',
  };

  return (
    <section className={['w-full', className].join('')}>
      <div
        style={{
          display: isRow ? 'flex' : 'block',
          justifyContent: isRow ? 'space-between' : undefined,
          alignItems: isRow ? 'flex-start' : undefined,
          gap: isRow ? '24px' : undefined,
        }}
      >
        <div className="w-full flex flex-col gap-[5px]">
          <div className={`flex flex-col ${!isRow && 'items-center'}`}>
            <div className="w-[116px] h-[25px] flex my-[10px]">
              <img src={base.vendorLogoUrl} alt={base.vendor} className="object-scale-down" />
            </div>
            <h3
              style={{
                fontWeight: 700,
                fontSize: isRow ? '22px' : '16px',
                lineHeight: '28px',
                textAlign: isRow ? 'left' : 'center',
              }}
            >
              {base.carSizeLabel} {base.carModelName}
            </h3>
            <p
              style={{
                fontWeight: 300,
                fontSize: '14px',
                lineHeight: '22px',
              }}
            >
              {base.carSpecText}
            </p>
          </div>
          {!isRow && base.carImageUrl && (
            <div style={imageContainerStyle}>
              <img
                src={base.carImageUrl}
                alt={base.carModelName}
                style={imageStyle}
                onError={handleImageError}
              />
              {base.footerNote && <p style={noteStyle}>{base.footerNote}</p>}
            </div>
          )}
          {infoSlot}
        </div>
        {isRow && base.carImageUrl && (
          <div style={imageContainerStyle}>
            <img
              src={base.carImageUrl}
              alt={base.carModelName}
              style={imageStyle}
              onError={handleImageError}
            />
            {base.footerNote && <p style={noteStyle}>{base.footerNote}</p>}
          </div>
        )}
      </div>
      {bannerSlot}
    </section>
  );
};
